<template>
  <div class="book-page">
    <div class="page-title">订单工具操作手册</div>
    <div class="content-body">
      <div class="content-box">
        <hll-doc :data="handbookInfo"></hll-doc>
      </div>
    </div>
  </div>

</template>

<script>
import HllDoc from "../common/hll-doc";

export default {
  name: "handbook",
  components: {HllDoc},
  data() {
    return {
      handbookInfo: {},
    }
  },
  mounted() {
    this.getBook();
  },
  methods: {
    getBook() {
      let documentId = 123;
      this.$axios.get("/ajax/guidance/document/detail", {
        params: {
          documentId: documentId,
        }
      }).then(res => {
        this.handbookInfo = res.data.data.info;
        if (!this.handbookInfo) {
          this.$message.warning('当前文档没有内容');
        }
      });
    },
  }
}
</script>

<style lang="scss">
.book-page {
  width: 1170px;
  padding: 0 0 30px;
  margin: 0 auto;

  .page-title {
    width: 100%;
    height: 32px;
    line-height: 32px;
    font-size: 20px;
    color: #212121;
    text-align: center;
    margin: 10px 0;
  }

  .content-body {
    position: relative;
    min-height: 500px;
    margin-top: 25px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  }

  .content-box {
    width: 100%;
    padding: 22px 25px 25px 270px;
    box-sizing: border-box;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/help/handbook.vue